'use strict';

function any (obj, key, cname, location, fullName) {
  return; // you can't fail to be 'any'
}

any.checkerName = 'any';

module.exports = any;



// WEBPACK FOOTER //
// ./lib/rlink-shapes/any.js